export default "__VITE_ASSET__CX0lEX4m__"